import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback, useContext } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import { EditCellContext } from 'src/contexts/EditCellContext';
import useRedirect from 'src/hooks/useRedirect';

const VarianceCell: FC<GridCellProps> = (props) => {
  const { getUrl, redirect } = useRedirect();
  const { dataItem, field } = props;
  const value = dataItem[field || ''];
  const [cellClick] = useContext(EditCellContext);
  const { openNewTab = true } = cellClick?.(null) || {};

  const handleClick = useCallback(() => {
    redirect(
      getUrl('varianceDetails')(props.dataItem.poId, props.dataItem.varianceId),
      false,
      openNewTab
    );
  }, [getUrl, openNewTab, props.dataItem.poId, props.dataItem.varianceId, redirect]);

  return (
    <GridCellBase {...props}>
      <button onClick={handleClick} className="text-link cursor-pointer underline">
        {value}
      </button>
    </GridCellBase>
  );
};

export default VarianceCell;
